// Inquiry Form Handler
document.addEventListener('DOMContentLoaded', function() {
  const contactForm = document.getElementById('ContactForm');
  if (!contactForm) return;

  contactForm.addEventListener('submit', async function(event) {
    event.preventDefault();

    const formData = new FormData(contactForm);
    const selectedProductsString = formData.get('contact[Selected Products]') || '';
    const selectedProducts = selectedProductsString
      .split(',')
      .map(item => item.trim())
      .filter(item => item.length > 0);

    try {
      setTimeout(function() {
        contactForm.submit();

        const inquireBubble = document.querySelector('[data-inquire-bubble]') ||
                             document.getElementById('inquireBubble');
        if (inquireBubble) {
          inquireBubble.textContent = '0';
        }

        localStorage.setItem('inquireList', JSON.stringify([]));
      }, 2000);
    } catch (error) {
      console.error('Inquiry form error:', error);
      alert('There was an issue. Please try again later.');
    }
  });
});
